module.exports = __webpack_public_path__ + "img/vegetable-garlic-scapes-350x184.cd211898.jpg";